/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageDto2 } from '../../models/image-dto-2';
import { ImageShowResponse } from '../../models/image-show-response';

export interface PatchImageUpdate$Params {
  id: string;
      body: ImageDto2
}

export function patchImageUpdate(http: HttpClient, rootUrl: string, params: PatchImageUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageShowResponse>> {
  const rb = new RequestBuilder(rootUrl, patchImageUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageShowResponse>;
    })
  );
}

patchImageUpdate.PATH = '/v1/image/{id}';
